import { Input, Label } from 'reactstrap';

const Checkbox = ({ id, label, name, ...props }) => {
  return (
    <>
      <Input
        id={id}
        name={name}
        type="checkbox"
        {...props}
        value={props.value || ''}
      />
      <Label>{label}</Label>
    </>
  );
};

export default Checkbox;
